// @ts-nocheck
/* Gift Certificate page — form behavior + hero parallax.
   Loaded as a standalone asset (not via the shared section script bundle). */
(function () {
  const form = document.getElementById('fv-gc-cart-form');
  if (!form) return;

  const CONTROL_FLAG_NAME = 'properties[__shopify_send_gift_card_to_recipient]';

  /* ── Denominations → variant id ───────────────────── */
  const amountBtns = form.querySelectorAll('.fv-gc-amount-btn');
  const variantInput = form.querySelector('#fv-gc-variant-id');

  function setActiveAmount(btn) {
    amountBtns.forEach(function (b) {
      b.classList.remove('fv-gc-amount-btn--active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('fv-gc-amount-btn--active');
    btn.setAttribute('aria-pressed', 'true');
    if (variantInput && btn.dataset.variantId) {
      variantInput.value = btn.dataset.variantId;
    }
  }

  amountBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.hasAttribute('disabled')) return;
      setActiveAmount(btn);
    });
  });

  /* ── Optional custom amount (hidden unless enabled) ── */
  const customInput = form.querySelector('#fv-gc-custom-amount');
  if (customInput) {
    customInput.addEventListener('input', function () {
      customInput.value = String(customInput.value || '').replace(/[^\d]/g, '');
    });
  }

  /* ── Delivery: send to me vs notify recipient ─────── */
  const deliveryTypeRadios = form.querySelectorAll('input[name="fv-gc-delivery-type"]');
  const recipientEmailField = form.querySelector('#fv-gc-recipient-email-field');
  const recipientEmailInput = form.querySelector('#fv-gc-recipient-email');
  const timingGroup = form.querySelector('#fv-gc-timing-group');
  const timezoneInput = form.querySelector('#fv-gc-timezone-offset');
  const dateField = form.querySelector('#fv-gc-date-field');
  const dateInput = form.querySelector('#fv-gc-delivery-date');
  const timingRadios = form.querySelectorAll('input[name="fv-gc-delivery-timing"]');

  function isNotifyRecipient() {
    const checked = form.querySelector('input[name="fv-gc-delivery-type"]:checked');
    return !!checked && checked.value === 'notify_recipient';
  }

  function isSpecificDate() {
    const checked = form.querySelector('input[name="fv-gc-delivery-timing"]:checked');
    return !!checked && checked.value === 'specific_date';
  }

  function addControlFlag() {
    if (form.querySelector('input[name="' + CONTROL_FLAG_NAME + '"]')) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = CONTROL_FLAG_NAME;
    input.value = 'on';
    input.id = 'fv-gc-control-flag';
    form.appendChild(input);
  }

  function removeControlFlag() {
    const el = form.querySelector('input[name="' + CONTROL_FLAG_NAME + '"]');
    if (el) el.remove();
  }

  /* The "Send on" date only submits when notifying a recipient on a specific date. */
  function updateDateState() {
    const showDate = isNotifyRecipient() && isSpecificDate();
    if (dateField) dateField.classList.toggle('fv-gc-form__field--hidden', !showDate);
    if (dateInput) {
      dateInput.disabled = !showDate;
      if (showDate) {
        dateInput.setAttribute('required', '');
      } else {
        dateInput.removeAttribute('required');
        dateInput.value = '';
      }
    }
  }

  function updateDeliveryState() {
    const notify = isNotifyRecipient();

    if (recipientEmailField) recipientEmailField.classList.toggle('fv-gc-form__field--hidden', !notify);
    if (recipientEmailInput) {
      recipientEmailInput.disabled = !notify;
      if (notify) {
        recipientEmailInput.setAttribute('required', '');
      } else {
        recipientEmailInput.removeAttribute('required');
        recipientEmailInput.value = '';
      }
    }

    if (timingGroup) timingGroup.classList.toggle('fv-gc-form__field--hidden', !notify);

    if (notify) {
      addControlFlag();
      if (timezoneInput) {
        timezoneInput.disabled = false;
        timezoneInput.value = String(new Date().getTimezoneOffset());
      }
    } else {
      removeControlFlag();
      if (timezoneInput) {
        timezoneInput.disabled = true;
        timezoneInput.value = '';
      }
    }

    updateDateState();
  }

  deliveryTypeRadios.forEach(function (r) {
    r.addEventListener('change', updateDeliveryState);
  });
  timingRadios.forEach(function (r) {
    r.addEventListener('change', updateDateState);
  });

  /* Constrain the date picker to today onward. */
  if (dateInput) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    dateInput.setAttribute('min', yyyy + '-' + mm + '-' + dd);
  }

  updateDeliveryState();
})();

/* ── Hero cloud parallax: drifts on scroll + eases toward the pointer ── */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hero = document.querySelector('.fv-gc-hero');
  if (!hero || reduce) return;

  var decos = Array.prototype.slice.call(hero.querySelectorAll('[data-depth]'));
  if (!decos.length) return;

  var items = decos.map(function (el) {
    return {
      el: el,
      drift: parseFloat(el.dataset.drift || '0'),
      depth: parseFloat(el.dataset.depth || '0'),
      sx: 0,
      mx: 0,
      my: 0,
    };
  });

  function apply(item) {
    item.el.style.setProperty('--fv-shift-x', (item.sx + item.mx).toFixed(2) + 'px');
    item.el.style.setProperty('--fv-shift-y', item.my.toFixed(2) + 'px');
  }

  /* Scroll drift: 0 when the hero is centered, ± toward the edges. */
  var scrollTicking = false;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var rect = hero.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var driftT = (vh / 2 - center) / vh;
      items.forEach(function (item) {
        if (!item.drift) return;
        item.sx = driftT * item.drift;
        apply(item);
      });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* Pointer parallax (fine pointers only): ease toward the cursor. */
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) {
    var targetX = 0;
    var targetY = 0;
    var curX = 0;
    var curY = 0;
    var running = false;

    function tick() {
      curX += (targetX - curX) * 0.08;
      curY += (targetY - curY) * 0.08;
      items.forEach(function (item) {
        item.mx = -curX * item.depth;
        item.my = -curY * item.depth;
        apply(item);
      });
      if (Math.abs(targetX - curX) < 0.001 && Math.abs(targetY - curY) < 0.001) {
        running = false;
      } else {
        requestAnimationFrame(tick);
      }
    }

    function start() {
      if (running) return;
      running = true;
      requestAnimationFrame(tick);
    }

    hero.addEventListener(
      'pointermove',
      function (event) {
        var rect = hero.getBoundingClientRect();
        targetX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        targetY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        start();
      },
      { passive: true }
    );

    hero.addEventListener(
      'pointerleave',
      function () {
        targetX = 0;
        targetY = 0;
        start();
      },
      { passive: true }
    );
  }
})();
